import {MetaTags} from '@frontend/components/MetaTags'
import {trans} from '@frontend/helpers'
import {useConfigureUi} from '@frontend/hooks'
import {PopularCategories} from '@frontend/modules/public/ads/components/PopularCategories'
import {HomePageAdsSection} from '@frontend/modules/public/home/components/HomePageAdsSection'
import {HomePageServicesSection} from '@frontend/modules/public/home/components/HomePageServicesSection'
import {useState} from 'react'

// Главная страница сайта.
export default function HomePage() {

    // Настройка глобальных элементов интерфейса приложения.
    useConfigureUi(config => {
        config.topMenu.wrapInCard = true
        config.topMenu.stickToTop = true
        return config
    })

    const [
        showServices,
        setShowServices,
    ] = useState<boolean>(false)

    return (
        <div className="container-fluid container-xl">
            <MetaTags
                title={trans().common.home_page_title}
            />
            <PopularCategories />
            <div className="flex-1 pb-4">
                <HomePageAdsSection
                    onAdsLoaded={action => setShowServices(action !== 'next')}
                />
                {showServices && (
                    <HomePageServicesSection />
                )}
            </div>
        </div>
    )
}
